<div class="modal edit-user-modal">
  <div class="modal-dialog modal-dialog-scrollable user-modal">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ 'user.edit.editUser' | translate }}</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
      </div>
      <div class="modal-body">
        <form class="edit-user-form" [formGroup]="editUserForm">
          <div class="input-container mb-3">
            <label for="editEmail">{{ 'user.edit.email' | translate }}</label>
            <input type="email" id="editEmail" formControlName="Email" value="" />
            <span class="error-text">{{ editUserFormErrors.Email }}</span>
          </div>
          <div class="input-container">
            <label for="editPhone">{{ 'user.edit.phoneNumber' | translate }}</label>
            <input
              type="text"
              id="editPhone"
              mask="(000) 000-0000"
              unmask="true"
              [validation]="false"
              formControlName="Phone"
              value=""
            />
            <span class="error-text">{{ editUserFormErrors.Phone }}</span>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <a
          role="button"
          class="button button-clear"
          aria-label="Close"
          (click)="close()"
          tabindex="0"
          (keydown.enter)="close()"
        >
          {{ 'common.cancel' | translate }}
        </a>
        <a
          role="button"
          class="button button-pink"
          (click)="editUser()"
          tabindex="0"
          (keydown.enter)="editUser()"
        >
          <span>
            @if (isLoadingEditUser()) {
              <span class="spinner-border spinner-border-sm"></span>
            }
            <span class="m-3">{{ 'common.save' | translate }}</span>
          </span>
        </a>
      </div>
    </div>
  </div>
</div>
